// It should be aligned with BE PayrollIntegrations::Kombo::Catalog::IntegrationTool enum
export const enum IntegrationTools {
  datev = 'datev',
  datevLug = 'datevlug',
  silae = 'silae',
}

export const enum IntegrationLabels {
  datev = 'DATEV',
  datevLug = 'DATEV',
  silae = 'Silae',
}
